<template>
  <path
    d="M5 5.50024C5 6.33024 5.67 7.00024 6.5 7.00024H10.5V17.5002C10.5 18.3302 11.17 19.0002 12 19.0002C12.83 19.0002 13.5 18.3302 13.5 17.5002V7.00024H17.5C18.33 7.00024 19 6.33024 19 5.50024C19 4.67024 18.33 4.00024 17.5 4.00024H6.5C5.67 4.00024 5 4.67024 5 5.50024Z"
  />
</template>
